import { SyncEngine, type SyncStatus } from "@el/sync";
import { useEffect, useState } from "react";
import { getLocal } from "./db";
import { deviceId, ulid } from "./ids";

let engine: SyncEngine | null = null;

export function getSync(): SyncEngine {
  if (!engine) {
    engine = new SyncEngine({
      store: getLocal().store,
      baseUrl: typeof location === "undefined" ? "" : location.origin,
      // Web は Cookie で認証する（同じオリジン）
      fetch: (input, init) => fetch(input, { ...init, credentials: "same-origin" }),
      auth: async () => ({}),
      deviceId: deviceId(),
      now: () => new Date().toISOString(),
      idFactory: () => ulid(),
    });
  }
  return engine;
}

const INITIAL: SyncStatus = { state: "syncing", pending: 0, lastSyncAt: null };

export function useSyncStatus(): SyncStatus {
  const [s, setS] = useState<SyncStatus>(INITIAL);
  useEffect(() => getSync().onStatus(setS), []);
  return s;
}

/** ヘッダーに出す同期の状態の文言（docs/design-system.md 4 章） */
export function syncLabel(s: SyncStatus): { text: string; tone: "ok" | "check" | "ng" } {
  switch (s.state) {
    case "synced":
      return s.pending > 0 ? { text: `送信待ち ${s.pending} 件`, tone: "check" } : { text: "同期済み", tone: "ok" };
    case "offline":
      return { text: s.pending > 0 ? `オフライン（送信待ち ${s.pending} 件）` : "オフライン", tone: "check" };
    case "syncing":
      return { text: "同期中", tone: "check" };
    case "error":
      return { text: "同期できない変更があります", tone: "ng" };
  }
}

/** 端末で保存した直後に、つながっていればすぐ送る */
export function syncSoon() {
  if (typeof navigator === "undefined" || navigator.onLine) void getSync().syncNow();
}

/** E2E・画面の検査で使う状態の名前（送信待ちがあれば pending） */
export function syncState(s: SyncStatus): "synced" | "pending" | "syncing" | "offline" | "error" {
  if (s.state === "synced" && s.pending > 0) return "pending";
  return s.state;
}
